import { computed, ref, getCurrentInstance} from "@vue/composition-api";
import store from "@/store";
import axios from "@/libs/axios";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import { encryptData } from "@/utils/encryptUserDataUtils";
import { debounce } from "lodash";
import { useTranslates } from "@/utils/useTranslates";

export function useDeviceInfo(device) {
  const toast = useToast();
  const deviceInfo = ref({})
  const isDeviceInfoLoading = ref(false)
  const showNoDataMessage = ref(false)

  store.dispatch('hanwha_camera/getVideoProfileSetup', device.device.id)
  store.dispatch('hanwha_camera/getVideoProfileAvailables', device.device.id)
  store.dispatch('hanwha_camera/getCurrentVideoProfile', device.device.id)

  async function getDeviceInfo() {
    try {
      const params = {
        idDvr: device.hanwha_dvr.id,
        channel: device.channel
      }
      isDeviceInfoLoading.value = true
      const {data} = await axios.get('/v1/hanwha/camera/admin/get_device_info', {params})

      deviceInfo.value = data.data

      if (Array.isArray(data.data) && data.data.length === 0) 
        showNoDataMessage.value = true
      
      isDeviceInfoLoading.value = false
    } catch(error) {
      isDeviceInfoLoading.value = false
      showNoDataMessage.value = true
      toast({
        component: ToastificationContent,
        props: {
          title: error?.response?.data?.message ?? 'Error getting device information',
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    }
  }

  return {
    deviceInfo,
    isDeviceInfoLoading,
    showNoDataMessage,
    getDeviceInfo,
  }
}